/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
//TODO: move it to a shared lib

//Small wrapper utility to allow defer loading AMD modules from webpack bundle
//Webpack collects all external deps and does require on them at the start of the bundle
//This tries to hide the require reference from webpack to prevent upfront requires
const loadModules = (arrModule, cb, cbErr) => {
	const reqFn = 'require';
	window[reqFn](arrModule, cb, cbErr );
};

const disabledLoader = false;
export { loadModules, disabledLoader };



// WEBPACK FOOTER //
// ./src/js/util/ModuleLoader.js